import React, { useEffect, useState } from "react";
import { Loader2, MonitorSmartphone, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import { useLang } from "../i18n";

const fmt = (iso, lang) => (iso ? new Date(iso).toLocaleString(lang === "es" ? "es-PA" : "en-US", { dateStyle: "short", timeStyle: "short" }) : "—");

export const TrustedDevices = () => {
  const { t, lang } = useLang();
  const [rows, setRows] = useState(null);
  const load = () => api.get("/auth/trusted-devices").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const revoke = async (id) => {
    await api.delete(`/auth/trusted-devices/${id}`);
    toast.success(t("sec.revoked"));
    load();
  };
  const revokeAll = async () => {
    await api.delete("/auth/trusted-devices");
    localStorage.removeItem("ec_device");
    toast.success(t("sec.revoked_all"));
    load();
  };

  return (
    <div className="space-y-3" data-testid="trusted-devices-section">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading text-base font-extrabold text-slate-900 flex items-center gap-2">
            <MonitorSmartphone className="w-4 h-4 text-[#044CBC]" /> {t("sec.devices")}
          </h3>
          <p className="text-xs text-slate-500 mt-0.5">{t("sec.devices_help")}</p>
        </div>
        {rows?.length > 0 && (
          <button type="button" onClick={revokeAll} data-testid="revoke-all-devices-button" className="shrink-0 px-3 py-1.5 rounded-lg border border-red-200 text-xs font-bold text-red-600 hover:bg-red-50">
            {t("sec.revoke_all")}
          </button>
        )}
      </div>
      {rows === null ? (
        <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
      ) : rows.length === 0 ? (
        <p className="text-sm text-slate-400 py-4 text-center border border-dashed border-slate-200 rounded-lg" data-testid="trusted-devices-empty">{t("sec.none")}</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-200" data-testid="trusted-devices-table">
          <table className="w-full text-sm min-w-[560px]">
            <thead>
              <tr className="bg-[#16335F] text-white text-left text-xs uppercase tracking-wide">
                <th className="px-3 py-2">{t("sec.device")}</th><th className="px-3 py-2">IP</th><th className="px-3 py-2">{t("sec.added")}</th>
                <th className="px-3 py-2">{t("sec.last_used")}</th><th className="px-3 py-2">{t("sec.expires")}</th><th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((d, i) => (
                <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`trusted-device-row-${i}`}>
                  <td className="px-3 py-2 text-xs text-slate-700">{d.device || "—"}</td>
                  <td className="px-3 py-2 font-mono text-xs text-slate-600">{d.ip || "—"}</td>
                  <td className="px-3 py-2 text-xs text-slate-600">{fmt(d.created_at, lang)}</td>
                  <td className="px-3 py-2 text-xs text-slate-600">{fmt(d.last_used_at, lang)}</td>
                  <td className="px-3 py-2 text-xs text-slate-600">{fmt(d.expires_at, lang)}</td>
                  <td className="px-3 py-2 text-right">
                    <button type="button" onClick={() => revoke(d.id)} data-testid={`revoke-device-${i}`} title={t("sec.revoke")} className="inline-flex items-center gap-1 text-xs font-bold text-red-600 hover:text-red-700">
                      <Trash2 className="w-3.5 h-3.5" /> {t("sec.revoke")}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
